module.exports = __webpack_public_path__ + "img/dribbble-white.ed532d40.svg";